<div class="flex flex-col gap-1.5">
	<div class="flex items-center justify-between gap-3 px-3 py-2 bg-wb-surface rounded-wb-sm border border-wb-border">
		<span class="text-[13px] font-semibold text-wb-text flex items-center gap-1.5">
			Contents
			@if (content().length > 0) {
				<span class="wb-count-badge">{{ content().length }}</span>
			}
		</span>
		<div class="flex gap-1.5 items-center">
			<p-select
				[options]="typeOptions"
				optionValue="value"
				appendTo="body"
				[ngModel]="newType()"
				(ngModelChange)="newType.set($event)"
			/>
			<button
				pButton
				size="small"
				(click)="addItem(newType())"
			><i class="pi pi-plus"></i>Add</button>
		</div>
	</div>

	@if (content().length === 0) {
		<div class="text-center text-wb-muted text-[12px] py-4 px-3 bg-wb-bg border border-dashed border-wb-border rounded-wb-sm">
			No content items. Use the dropdown above to add one.
		</div>
	}

	@for (item of content(); track $index; let i = $index) {
		<app-content-item-card
			[item]="item"
			[index]="i"
			[total]="content().length"
			[aeComp]="aeComp()"
			(itemChange)="updateItem(i, $event)"
			(requestRemove)="removeItem(i)"
			(requestMoveUp)="moveItem(i, -1)"
			(requestMoveDown)="moveItem(i, 1)"
			(requestCopy)="copyItem.emit(item)"
		/>
	}
</div>
